import { BulkActionType, IBulkImpact } from '../services/common/common.model';

// Normalise typed confirmation text so "delete 81,195" matches "DELETE 81195":
// case-insensitive, commas ignored, runs of whitespace collapsed, ends trimmed.
export const normalizeConfirmText = (text: string | null | undefined): string => {
  return (text ?? '').toString().toUpperCase().replace(/,/g, '').replace(/\s+/g, ' ').trim();
};

export const isConfirmTextMatch = (
  typed: string | null | undefined,
  expected: string | null | undefined
): boolean => {
  const target = normalizeConfirmText(expected);
  return target.length > 0 && normalizeConfirmText(typed) === target;
};

// "Companies: 3 · BUs: 5 · Tenants: 2 · Dates (Date Added): 4" - a dimension is omitted
// when the server reports null (the table has no such column).
export const formatImpactDimensions = (impact: IBulkImpact | null | undefined): string => {
  if (!impact) {
    return '';
  }
  const parts: Array<[string, number | null | undefined]> = [
    ['Companies', impact.companies],
    ['BUs', impact.bus],
    ['Tenants', impact.tenants],
    ['Dates (Date Added)', impact.dates],
  ];
  return parts
    .filter(([, value]) => value !== null && value !== undefined)
    .map(([label, value]) => `${label}: ${Number(value).toLocaleString()}`)
    .join(' · ');
};

export interface IBulkActionRejection {
  status?: number;
  message?: string;
}

// Shape a failed bulk-update / bulk-delete request into a serialisable rejection value
// so the reducer can tell an HTTP 409 "confirmation required" apart from other errors.
export const getBulkActionRejection = (error: any): IBulkActionRejection => {
  const status = error?.response?.status;
  const body = error?.response?.data?.body;
  const errors = body?.errors ?? error?.response?.data?.message;
  const message = Array.isArray(errors) ? errors.join(' ') : errors ?? error?.message;
  return { status, message: message ? String(message) : undefined };
};

export const bulkActionLabel = (action: BulkActionType): string =>
  action === 'delete' ? 'Delete' : 'Update';
